import React from 'react';
import { Box, Typography, Link, Container } from '@mui/material';

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <Box
            component="footer"
            sx={{
                mt: 'auto',
                py: 3,
                px: 2,
                backgroundColor: 'background.paper',
                borderTop: 1,
                borderColor: 'divider',
            }}
        >
            <Container maxWidth="lg">
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: { xs: 1, sm: 3 },
                        textAlign: 'center',
                        flexWrap: 'wrap',
                    }}
                >
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                    >
                        © {currentYear} Radiology Illustration. All rights reserved.
                    </Typography>

                    <Link
                        href="/contact"
                        color="text.secondary"
                        underline="hover"
                        sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                    >
                        Contact
                    </Link>

                    <Link
                        href="/privacy-policy"
                        color="text.secondary"
                        underline="hover"
                        sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                    >
                        Privacy Policy
                    </Link>

                    <Link
                        href="/terms"
                        color="text.secondary"
                        underline="hover"
                        sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                    >
                        Terms
                    </Link>

                    <Link
                        href="/disclaimer"
                        color="text.secondary"
                        underline="hover"
                        sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                    >
                        Disclaimer
                    </Link>

                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                    >
                        Website developed by{' '}
                        <Link
                            href="https://nswebopps.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                                color: 'primary.main',
                                textDecoration: 'none',
                                fontSize: 'inherit',
                                '&:hover': {
                                    textDecoration: 'underline',
                                },
                            }}
                        >
                            Naman Singh
                        </Link>
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;
